import {
    Card,
    Button,
    ButtonGroup
} from "@nike/eds";
import React, {useState} from "react";
import {QuantityAdjustmentElcForm} from "../adjust-quantity-elc/QuantityAdjustmentElcForm";
import {QuantityAdjustmentDrsForm} from "../adjust-quantity-drs/QuantityAdjustmentDrsForm";
import {edsSpace32} from "@nike/eds/dist/tokens";

enum Location {
    ELC = "ELC",
    GENK = "GENK",
    TRANSIT = "TRANSIT"
}

const locationDisplayNames = {
    [Location.ELC]: "ELC",
    [Location.GENK]: "Genk",
    [Location.TRANSIT]: "Transit"
};

function LocationForm({formState, inventoryService, onClose, host}) {
    switch(formState) {
        case Location.ELC:
            return <QuantityAdjustmentElcForm inventoryService={inventoryService} onClose={onClose} host={host}/>;
        case Location.TRANSIT:
            return <QuantityAdjustmentDrsForm inventoryService={inventoryService} onClose={onClose} host={host} location={Location.TRANSIT}/>;
        case Location.GENK:
            return <QuantityAdjustmentDrsForm inventoryService={inventoryService} onClose={onClose} host={host} location={Location.GENK}/>;
        default:
            return null;
    }
}

function QuantityAdjustment({inventoryService, onClose, host}) {
    const [ formState, setFormState ] = useState<Location>(Location.ELC);

    const buttonGroupStyle = {
        marginBottom: edsSpace32,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "0px"
    };

    const buttonStyle = {
        borderRadius: 0,
        width: "100px",
        height: "40px"
    };

    const renderButtons = () => {
        return Object.entries(locationDisplayNames).map(([location, displayName]) => (
            <Button
                key={location}
                style={buttonStyle}
                variant={formState === location ? "primary" : "secondary"}
                onClick={() => setFormState(location as Location)}
            >
                {displayName}
            </Button>
        ));
    };

    return (
        <div className="eds-grid eds-elevation--4">
            <Card>
                <div>
                    <ButtonGroup
                        style={buttonGroupStyle}
                        className="eds-button-group"
                    >
                        {renderButtons()}
                    </ButtonGroup>
                </div>

                <div>
                    <LocationForm
                        formState={formState}
                        inventoryService={inventoryService}
                        onClose={onClose}
                        host={host}
                    />
                </div>
            </Card>
        </div>
    );
}

export {QuantityAdjustment};
